import update from 'immutability-helper';
import { SET_LOGGED_IN_STATUS } from 'marketing-website/constants/actions';

import readCookie from '../utils/readCookie';

const testGroupNumber = readCookie('test_group_number');

const initialState = {
  isLoggedIn: false,
  isSubscribed: false,
  isCheckingUserStatus: true,
  username: '',
  email: null,
  companyName: null,
  testGroupNumber: testGroupNumber && Number(testGroupNumber),
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOGGED_IN_STATUS:
      return update(state, {
        isLoggedIn: { $set: action.isLoggedIn },
        isSubscribed: { $set: action.isSubscribed },
        isCheckingUserStatus: { $set: false },
        username: { $set: action.username || '' },
        email: { $set: action.email || '' },
        companyName: { $set: action.companyName || '' },
        testGroupNumber: { $set: action.testGroupNumber || null },
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js